import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { SelectedCompanyCurrency } from '../../../../components/selected-company-currency/index';
import { useFormat } from '../../../../hooks/index';
import { eventFormType, EventTypeBackend } from '../../../../types/events.types';
import { CardProps } from './transaction-card-variants.types';
import { TransactionOverviewItem } from './transaction-overview-item';
import { TransactionTitleItem } from './transaction-title-item';

export const Approval: FC<CardProps> = ({ event }) => {
  const { format } = useFormat();

  if (event.type !== EventTypeBackend.APPROVAL) return <></>;

  const {
    type,
    exercise: { items },
    createdAt,
  } = event;

  return (
    <>
      {items.map(({ id, vestingTask }) => (
        <div className="flex flex-col divide-y divide-gray-100 rounded-md shadow-sm" key={id}>
          <TransactionTitleItem
            createdAt={format(createdAt, 'dd/MM/yyyy')}
            name={<AppFormattedMessage id={eventFormType[type]} />}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="TRANSACTION_TYPE" />}
            value={<AppFormattedMessage id={eventFormType[type]} />}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="STAKEHOLDER" />}
            value={`Hurdle Plan ${vestingTask.grantItem.stakeholder.fullName}`}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="SHARE_CLASS" />}
            value={vestingTask.grantItem.plan.pool.shareClass.name}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="HURDLE_VALUE" />}
            value={
              <>
                <SelectedCompanyCurrency />
                {vestingTask.grantItem.plan.hardleValue?.toLocaleString('en-US')}
              </>
            }
          />
        </div>
      ))}
    </>
  );
};
